export const CommentMarkName = 'commentMark';
